module.exports = __webpack_public_path__ + "static/media/Website_Icon.c05f409d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/footer/Website_Icon.png
// module id = 1562
// module chunks = 0